export default __webpack_public_path__ + "static/media/ic_close.7f76e6a6.svg";